import { keepPreviousData, queryOptions } from '@tanstack/react-query';

import type {
  BookingCalendarQueryParams,
  BookingCalendarResponse,
} from '@/types/api/queries';

import { HttpClient } from '@/network/HttpClient';

export const bookingCalendarKeys = {
  all: () => ['bookingCalendar'] as const,
  day: (props: BookingCalendarQueryParams) =>
    [
      ...bookingCalendarKeys.all(),
      'day',
      props.url,
      props.locationId,
      props.date,
    ] as const,
};

export const bookingCalendarQueries = {
  day: (props: BookingCalendarQueryParams) =>
    queryOptions({
      queryKey: bookingCalendarKeys.day(props),
      queryFn: () =>
        HttpClient.request<BookingCalendarResponse>({
          method: 'GET',
          url: props.url,
          params: { location_id: props.locationId, date: props.date },
        }),
      enabled: !!props.url && !!props.locationId && !!props.date,
      placeholderData: keepPreviousData,
      refetchOnWindowFocus: false,
    }),
};
